import React from "react";
import { Link } from "react-router-dom";
import { Training } from "../../data/clearith";

interface CourseCardProps {
  training: Training;
  featured?: boolean;
}

const CourseCard: React.FC<CourseCardProps> = ({ training, featured = false }) => (
  <article className={`cl-course-card ${featured ? "is-featured" : ""}`}>
    <div className="cl-course-card__top">
      <div>
        <span className="cl-kicker">Formation certifiante</span>
        <h3>{training.title}</h3>
      </div>
      <span className="cl-rs-badge">RS6905</span>
    </div>
    <p className="cl-course-card__certification">{training.certification}</p>
    <div className="cl-course-card__facts">
      <span>
        <strong>Durée</strong>
        {training.duration}
      </span>
      <span>
        <strong>Rythme</strong>
        {training.rhythm}
      </span>
      <span>
        <strong>Modalité</strong>
        À distance
      </span>
      <span>
        <strong>Tarif</strong>
        {training.price}
      </span>
    </div>
    <p>{training.objective}</p>
    <div className="cl-course-card__actions">
      <Link
        className="thm-btn agency-btn"
        to={`/formations/${training.slug}`}
      >
        <span className="text">Découvrir la formation</span>
      </Link>
      <Link className="cl-text-link" to="/contact">
        Demander des informations <span aria-hidden="true">↗</span>
      </Link>
    </div>
  </article>
);

export default CourseCard;
